import { call, put } from 'redux-saga/effects';
import { getAssigneeShopInfoFailureAction, getAssigneeShopInfoSuccessAction } from '../actions';
import { AssigneeShopInfoService } from '../services';
export function* getAssigneeShopInfoSaga(action, assigneeShopInfoService = AssigneeShopInfoService.getInstance()) {
    try {
        const assigneeCode = action.payload;
        const response = yield call({
            context: assigneeShopInfoService,
            fn: assigneeShopInfoService.getAssigneeShopInfo
        }, assigneeCode);
        yield put(getAssigneeShopInfoSuccessAction(response));
    }
    catch (ex) {
        yield put(getAssigneeShopInfoFailureAction(ex.toString()));
    }
}
//# sourceMappingURL=getAssigneeShopInfoSaga.js.map